import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation DeleteEventClassification($id: Int!) {
    deleteEventClassification(id: $id) {
      id
    }
  }
`);

export interface DeleteGql {
  deleteEventClassification: {
    id?: number;
  };
}
